<script setup lang="ts">
import { datadogLogs } from '@datadog/browser-logs'

const { error } = defineProps({
  error: Object,
})

interface StoryBlokError {
  items: {
    code: string
    title: string
    text: StoryBlokRichText
    image: StoryBlokImage
  }[]
  homeButton: StoryBlokButton[]
  tiles: any
}

onMounted(() => {
  datadogLogs.logger.critical(`[${error.statusCode}] ${error.message}`, {}, error)
})

const isMenuOpen = ref(false)

const sbApi = useStoryblokApiV2()
const data = (await sbApi.getStories<{ content: any; slug: 'error' | 'navigation' | 'footer' }>({
  by_slugs: ['layout/*'],
})).stories

const errorData: StoryBlokError = data.find(item => item.slug === 'error')?.content
const errorItems = errorData?.items || []
const errorItem = errorItems.find(item => Number(item.code) === error?.statusCode)!
</script>

<template>
  <div>
    <TheNavigation
      v-model:is-menu-open="isMenuOpen"
      v-bind="data.find(item => item.slug === 'navigation')?.content"
    />
    <div class="flex lg:pb-10 pt-4 md:pt-10 flex flex-col relative bg-gradient-to-br from-tertiary to-primary w-full">
      <div class="lg:max-w-1000px lg:mx-auto">
        <div class="px-5 z-1 flex flex-col md:text-center lg:text-left gap-2">
          <h1>{{ errorItem.title }}</h1>
          <StoryblokRichText :document="errorItem.text" />
          <div class="button-style z-3 mt-4 mb-10 md:mt-8 md:mb-14">
            <StoryblokButton v-bind="errorData.homeButton[0]" class="<md:w-full" />
          </div>
        </div>
        <div class="flex w-full justify-center">
          <div class="pb-18 px-18 lg:px-0">
            <StoryblokImage :src="errorItem.image" />
          </div>
        </div>
      </div>
    </div>
    <TheFooter v-bind="data.find(item => item.slug === 'footer')?.content" />
  </div>
</template>

<style lang="scss">
.button-style > div > a {
    @apply sm:justify-center lg:justify-start;
}
</style>
